import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../../admin/services/admin.service';
import { ReceiptItem } from '../../admin/expense-dashboard/receipt-item';
import { ApiDataResponse, ApiResponse } from '../../../shared/model/api-response.model';
import { HRContactGet_Result } from '../../../type-definitions/employee/responses/employee';
import { EmployeeInfo } from '../../../type-definitions/home/responses/home';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getEmergencyContactList(selectedEmployee: number, pRCo: number): Promise<ApiDataResponse<HRContactGet_Result[]>> {
    const url = `/Employee/EmerConGet?employee=${selectedEmployee}&pRCo=${pRCo}`;
    return this.http.get<ApiDataResponse<HRContactGet_Result[]>>(url).toPromise();
  }

  getECEmployees() {
    return this.http.get('/Employee/GetProxyEmployeesForUpdateInfo').toPromise();
  }

  getECRelationship() {
    return this.http.get('/Employee/GetECRelationship').toPromise();
  }

  getStateLookup() {
    return this.http.get('/Employee/GetDependentLookupByColumnName?columnName=State').toPromise();
  }

  updateEmergencyContact(params: HttpParams): Promise<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/EmerConUpdate', params).toPromise();
  }

  deleteEmergencyContact(hRECKeyID: any): Promise<ApiResponse> {
    return this.http
      .post<ApiResponse>('/Employee/EmerConGeDelete', {
        hRECKeyID: hRECKeyID,
      })
      .toPromise();
  }

  getEarningsType() {
    return this.http.get('/Employee/EarningsType').toPromise();
  }

  getDocuments(selectedDocTypes: any, fromDate: string, toDate: string) {
    return this.http
      .post('/Document/Get', {
        docTypes: selectedDocTypes,
        fromDate: fromDate,
        toDate: toDate,
      })
      .toPromise();
  }

  getBulletinsGetIndex(sectiontoLoad?: string, bulletinID?: number) {
    var url = '/Employee/GetBulletinsGetIndex?sectionToLoad=' + sectiontoLoad + '&bulletinID=' + bulletinID;
    return this.http.get(url).toPromise();
  }

  getLookups(parameters: string) {
    var url = '/Employee/GetLookups?' + parameters;
    return this.http.get(url).toPromise();
  }

  getMileageRate(currentPRCo?: number) {
    var url = '/Employee/GetMileageRate' + (currentPRCo != null ? '?pRCo=' + currentPRCo : '');
    return this.http.get(url).toPromise();
  }

  addEditMileageRate(expenseMileageRateID: any, mileageRate: any, rateDescription: any, pRCo: any) {
    return this.http
      .post('/Employee/AddEditMileageRate', {
        expenseMileageRateID: expenseMileageRateID,
        mileageRate: mileageRate,
        rateDescription: rateDescription,
        pRCo: pRCo,
      })
      .toPromise();
  }

  deleteMileageRate(expenseMileageRateID: any) {
    return this.http
      .post('/Employee/DeleteMileageRate', {
        expenseMileageRateID: expenseMileageRateID,
      })
      .toPromise();
  }

  getTaxCodes(taxType: any) {
    var url = '/Employee/GetTaxCodes?taxType=' + taxType;
    return this.http.get(url).toPromise();
  }

  getEarnCodes(currentPRCo: number) {
    var url = '/Employee/GetEarnCodes?pRCo=' + currentPRCo;
    return this.http.get(url).toPromise();
  }

  getCustomerNames(customerName: any) {
    var url = '/Employee/GetCustomerNames?searchString=' + customerName;
    return this.http.get(url);
  }

  getReviewers(selectedReviewer: any) {
    var url = '/Employee/GetReviewers?searchString=' + selectedReviewer;
    return this.http.get(url);
  }

  getlookupURL(lookupURL) {
    return this.http.get(lookupURL);
  }

  catgGet() {
    return this.http.get('/Employee/CatgGet').toPromise();
  }

  expenseSettingsByPRCo(prCo: number) {
    var url = '/Employee/ExpenseSettingsByPRCo?pRCo=' + prCo;
    return this.http.get(url).toPromise();
  }

  submitItems(receiptIDString: any, headerDescription?: any, proxyUserKeyID?: any, receiptItemID?: number) {
    return this.http
      .post('/Employee/SubmitItems', {
        receiptIDString: receiptIDString,
        headerDescription: headerDescription,
        proxyUserKeyID: proxyUserKeyID,
        receiptItemID: receiptItemID,
      })
      .toPromise();
  }

  addReviewer(reviewer: any, receiptItemID?: any, expenseHeaderID?: any) {
    return this.http
      .post('/Employee/AddReviewer', {
        reviewer: reviewer,
        receiptItemID: receiptItemID,
        expenseHeaderID: expenseHeaderID,
      })
      .toPromise();
  }

  getFieldsByLineItem(lineChargeType: any, pOLineType: any) {
    var url = '/APRouter/GetFieldsByLineItem?lineType=' + lineChargeType + '&pOLineType=' + pOLineType;
    return this.http.get(url).toPromise();
  }

  getLineAttachments(receiptID: number, receiptItemID?: string, fromApproval?: boolean): Promise<LineAttachment[]> {
    var url = '/Employee/GetLineAttachments?receiptID=' + receiptID + '&receiptItemID=' + receiptItemID + '&fromApproval=' + fromApproval;
    return this.http.get<LineAttachment[]>(url).toPromise();
  }

  addAttachment(receiptID: any, receiptItemID: any, photoFileData: any, photoFileType: any, attachmentCaption?: string) {
    return this.http
      .post('/Employee/AddAttachment', {
        receiptID: receiptID,
        receiptItemID: receiptItemID,
        photoFileData: photoFileData,
        photoFileType: photoFileType,
        attachmentCaption: attachmentCaption,
      })
      .toPromise();
  }

  getCreditCardList(selectedEmployee: any) {
    var url = '/Employee/GetUnReconciledLines?userKeyID=' + (selectedEmployee === null ? null : selectedEmployee.UserKeyID);
    return this.http.get(url).toPromise();
  }

  getCategory() {
    var url = '/Employee/CatgGet';
    return this.http.get(url).toPromise();
  }

  catgAddEdit(expenseCatgID: any, expenseCatgName: any, isActive: any) {
    return this.http
      .post('/Employee/CatgAddEdit', {
        expenseCatgID: expenseCatgID,
        expenseCatgName: expenseCatgName,
        isActive: isActive,
      })
      .toPromise();
  }

  catgDelete(expenseCatgID: any) {
    return this.http
      .post('/Employee/CatgDelete', {
        expenseCatgID: expenseCatgID,
      })
      .toPromise();
  }

  transAction(expenseTransID: any, userKeyID: any, where: any, matchedExpenseReceiptID: any, transAmount: any, prCo?: any) {
    return this.http
      .post('/Employee/TransAction', {
        expenseTransID: expenseTransID,
        userKeyID: userKeyID,
        where: where,
        matchedExpenseReceiptID: matchedExpenseReceiptID,
        transAmount: transAmount,
        prCo: prCo,
      })
      .toPromise();
  }

  getFieldValuesByPOItem(pO: any, pOItem: any, pOItemLine: any, aPCo: any) {
    var url = '/APRouter/GetFieldValuesByPOItem?pO=' + pO + '&pOItem=' + pOItem + '&pOItemLine=' + pOItemLine + '&aPCo=' + aPCo;
    return this.http.get(url).toPromise();
  }

  getRawAttachmentData(attachmentID: any, keepOriginal?: any) {
    var url = '/Document/GetRawAttachmentData?attachmentID=' + attachmentID + '&keepOriginal=' + keepOriginal;
    return this.http.get(url).toPromise();
  }

  removeAttachment(expenseAttachmentID: any) {
    return this.http
      .post('/Employee/RemoveAttachment', {
        expenseAttachmentID: expenseAttachmentID,
      })
      .toPromise();
  }

  unlinkItem(userKeyID: any, receiptID: any) {
    return this.http
      .post('/Employee/UnlinkItem', {
        receiptID: receiptID,
        userKeyID: userKeyID,
      })
      .toPromise();
  }

  getUserFields() {
    return this.http.get('/Employee/GetUserFields').toPromise();
  }

  getFieldOptions(fieldId: any) {
    return this.http.get('/Employee/GetComboItemsByFieldID?fieldID=' + fieldId).toPromise();
  }

  personalInfoAttachmentSubmit(docCount: number) {
    return this.http
      .post('/Employee/PersonalInfoAttachmentSubmit', {
        docCount: docCount,
      })
      .toPromise();
  }

  saveFileAttachment(
    moduleID: number,
    recordID: number,
    attachmentFileData: any,
    attachmentFileName: string,
    attachmentType: string,
    onboarding?: boolean,
    recordGuid?: any,
    attachmentTypeID?: number
  ) {
    return this.http
      .post('/Employee/SaveFileAttachment', {
        moduleID: moduleID,
        recordID: recordID,
        attachmentFileData: attachmentFileData,
        attachmentFileName: attachmentFileName,
        attachmentType: attachmentType,
        onboarding: onboarding,
        recordGuid: recordGuid,
        AttachmentTypeID: attachmentTypeID,
      })
      .toPromise();
  }

  saveEmployeePhotoConsentReport(moduleID: number, recordID: number, submissionGuid: string) {
    return this.http
      .post('/Employee/saveEmployeePhotoConsentReport', {
        moduleID: moduleID,
        recordID: recordID,
        submissionGuid: submissionGuid,
      })
      .toPromise();
  }

  sendEmail() {
    return this.http.post('/Employee/SendEmail', {}).toPromise();
  }

  updateUserWindow(
    benefitUserWindowID?: number,
    windowTypeID?: number,
    windowStartDateString?: string,
    windowEndDateString?: string,
    isWindowRequestApproved?: boolean,
    isPersonalInfoFinished?: boolean,
    isDependentUpdateFinished?: boolean,
    isBenefitReviewCompleted?: boolean,
    isWindowConfirmed?: boolean,
    userKeyID?: number,
    requesterNotes?: string,
    approverNotes?: string,
    cancelWindow?: boolean,
    requestedEffectiveDateStr?: string,
    fromURL?: string
  ) {
    return this.http
      .post('/Employee/UpdateUserWindow', {
        benefitUserWindowID: benefitUserWindowID,
        windowTypeID: windowTypeID,
        windowStartDateString: windowStartDateString,
        windowEndDateString: windowEndDateString,
        isWindowRequestApproved: isWindowRequestApproved,
        isPersonalInfoFinished: isPersonalInfoFinished,
        isDependentUpdateFinished: isDependentUpdateFinished,
        isBenefitReviewCompleted: isBenefitReviewCompleted,
        isWindowConfirmed: isWindowConfirmed,
        userKeyID: userKeyID,
        requesterNotes: requesterNotes,
        approverNotes: approverNotes,
        cancelWindow: cancelWindow,
        requestedEffectiveDateStr: requestedEffectiveDateStr,
        fromURL: fromURL,
      })
      .toPromise();
  }

  getDependents(proxyUserKeyID?: number) {
    return this.http.get('/Employee/GetDependents?proxyUserKeyID=' + proxyUserKeyID).toPromise();
  }

  submitDependents(hRDPKeyID: number, formData: any, isRemove: boolean, userID: number | null) {
    return this.http
      .post('/Employee/SubmitDependentRequest', {
        hRDPKeyID: hRDPKeyID,
        formData: formData,
        isRemove: isRemove,
        userID: userID,
      })
      .toPromise();
  }

  personalInfoUpdate(
    formData: string,
    isAddressInvalid: boolean,
    attachmentsJson: string,
    fileNamesJson: string,
    recordKeyID: any,
    submissionGuid: any
  ) {
    return this.http
      .post('/Employee/PersonalInfoUpdate', {
        formData: formData,
        isAddressInvalid: isAddressInvalid,
        attachmentsJson: attachmentsJson,
        fileNamesJson: fileNamesJson,
        recordKeyID: recordKeyID,
        submissionGuid: submissionGuid,
      })
      .toPromise();
  }

  getW4() {
    return this.http.get('/Employee/GetW4').toPromise();
  }

  getDependentLookupByColumnName(columnName: string, countryCode?: string) {
    return this.http
      .get('/Employee/GetDependentLookupByColumnName?columnName=' + columnName + (countryCode != null ? '&countryCode=' + countryCode : ''))
      .toPromise();
  }

  getFilingStatus(useConfigSetting?: boolean) {
    var url = '/Employee/GetFilingStatus?useConfigSetting=' + useConfigSetting;
    return this.http.get(url).toPromise();
  }

  w4Update(
    dLCode: number,
    fileStatus: any,
    regExempts: any,
    miscAmt: number,
    signatureData: any,
    miscFactor: any,
    manualFileAttachment: any,
    manualFileName: string,
    latitude: any,
    longitude: any,
    IsExempt2020: boolean,
    multiJobs2020: boolean,
    otherIncome2020: number,
    dependentAmt2020: number,
    deductions2020: number,
    qualChildAmount: number,
    otherDependentAmount: number
  ) {
    return this.http.post('/Employee/W4Update', {
      dLCode: dLCode,
      fileStatus: fileStatus,
      regExempts: regExempts,
      miscAmt: miscAmt,
      signatureData: signatureData,
      miscFactor: miscFactor,
      manualFileAttachment: manualFileAttachment,
      manualFileName: manualFileName,
      latitude: latitude,
      longitude: longitude,
      IsExempt2020: IsExempt2020,
      multiJobs2020: multiJobs2020,
      otherIncome2020: otherIncome2020,
      dependentAmt2020: dependentAmt2020,
      deductions2020: deductions2020,
      qualChildAmount: qualChildAmount,
      otherDependentAmount: otherDependentAmount,
    });
  }

  getTypeSign(type: string, name: string = null) {
    let url = '/Checklist/GetTypeSign?type=' + type;
    if (name != null) url += '&name=' + name;
    return this.http.get(url).toPromise();
  }

  getDirectDepositInfo() {
    return this.http.get('/Employee/GetDirectDepositInfo').toPromise();
  }

  submitDirectDepositUpdate(data: any) {
    return this.http
      .post('/Employee/SubmitDirectDepositUpdate', {
        routing1: data.routing1,
        routing2: data.routing2,
        routing3: data.routing3,
        routing4: data.routing4,
        account1: data.account1,
        account2: data.account2,
        account3: data.account3,
        account4: data.account4,
        accountType1: data.accountType1,
        accountType2: data.accountType2,
        accountType3: data.accountType3,
        accountType4: data.accountType4,
        acccount1Unit: data.account1Unit,
        account2Unit: data.account2Unit,
        account3Unit: data.account3Unit,
        account4Unit: data.account4Unit,
        account1Amt: data.account1Amt,
        account2Amt: data.account2Amt,
        account3Amt: data.account3Amt,
        account4Amt: data.account4Amt,
        checkImage1: data.checkImage1,
        checkImage2: data.checkImage2,
        checkImage3: data.checkImage3,
        checkImage4: data.checkImage4,
        checkImageName1: data.checkImageName1,
        checkImageName2: data.checkImageName2,
        checkImageName3: data.checkImageName3,
        checkImageName4: data.checkImageName4,
        account1Updated: data.account1Updated,
        account2Updated: data.account2Updated,
        account3Updated: data.account3Updated,
        account4Updated: data.account4Updated,
        account2KeyID: data.account2KeyID,
        account3KeyID: data.account3KeyID,
        account4KeyID: data.account4KeyID,
      })
      .toPromise();
  }

  getDepartments() {
    var url = '/Employee/GetDepartments';
    return this.http.get(url).toPromise();
  }

  submitSupportRequest(
    supportDepartmentID: number,
    requestDescription: string,
    facilityLocation: string,
    isUrgent: boolean,
    isApproved: boolean,
    requestEmailHTML: string,
    emailAddress: string
  ) {
    return this.http
      .post('/Employee/SubmitSupportRequest', {
        supportDepartmentID: supportDepartmentID,
        requestDescription: requestDescription,
        facilityLocation: facilityLocation,
        isUrgent: isUrgent,
        isApproved: isApproved,
        requestEmailHTML: requestEmailHTML,
        emailAddress: emailAddress,
      })
      .toPromise();
  }

  submitAttachment(moduleID: number, recordID: number, attachmentData: any, attachmentFileName: string) {
    return this.http
      .post('/Employee/SubmitSupportRequest', {
        moduleID: moduleID,
        recordID: recordID,
        attachmentData: attachmentData,
        attachmentFileName: attachmentFileName,
      })
      .toPromise();
  }

  getRequestsByID(supportRequestID: number) {
    var url = '/Employee/GetRequestsByID?supportDepartmentID=' + supportRequestID;
    return this.http.get(url).toPromise();
  }

  getAssign(supportDepartmentID: number) {
    var url = '/Employee/GetAssign?supportDepartmentID=' + supportDepartmentID;
    return this.http.get(url).toPromise();
  }

  cancelDependentRequest(dependentRequestID: number) {
    return this.http
      .post('/Employee/CancelDependentRequest', {
        dependentRequestID: dependentRequestID,
      })
      .toPromise();
  }

  getDependentFields(keyID: number) {
    var url = '/Employee/GetDependentFields?keyID=' + keyID;
    return this.http.get(url).toPromise();
  }

  getRelationship() {
    var url = '/Employee/GetRelationship';
    return this.http.get(url).toPromise();
  }

  getFileAttachmentList(requestParam: string) {
    var url = '/Employee/GetFileAttachmentList?' + requestParam;
    return this.http.get(url).toPromise();
  }

  getTrainingCompany() {
    var url = '/Employee/GetTrainingCompany';
    return this.http.get(url).toPromise();
  }

  getPositionCodes(selectedHRCo: number) {
    var url = '/Employee/GetPositionCodes?hRCo=' + selectedHRCo;
    return this.http.get(url).toPromise();
  }

  getCareerPaths(selectedHRCo: number) {
    var url = '/Employee/GetCareerPaths?hRCo=' + selectedHRCo;
    return this.http.get(url).toPromise();
  }

  getCareerPathMapping(selectedCareerID: number) {
    var url = '/Employee/GetCareerPathMapping?careerPathID=' + selectedCareerID;
    return this.http.get(url).toPromise();
  }

  careerPathUpdate(careerPathID: number, careerPathName: string, hRCo: number) {
    return this.http
      .post('/Employee/CareerPathUpdate', {
        careerPathID: careerPathID,
        careerPathName: careerPathName,
        hRCo: hRCo,
      })
      .toPromise();
  }

  getEmpCareerPath(careerPathID: number, employeeCurrentPosition: any = null) {
    var url = '/Employee/GetEmpCareerPath?careerPathID=' + careerPathID + '&positionSeq=' + employeeCurrentPosition;
    return this.http.get(url).toPromise();
  }

  empCareerPathUpdate(careerPathMapID: number, hRPCKeyID: number, seq: number, actionStr: string, careerPathID: number) {
    return this.http
      .post('/Employee/EmpCareerPathUpdate', {
        careerPathID: careerPathID,
        careerPathMapID: careerPathMapID,
        hRPCKeyID: hRPCKeyID,
        seq: seq,
        actionStr: actionStr,
      })
      .toPromise();
  }

  getEmployeeTrainingPath() {
    var url = '/Employee/GetEmployeeTrainingPath';
    return this.http.get(url).toPromise();
  }

  careerPathDelete(selectedCareerID: number) {
    return this.http
      .post('/Employee/CareerPathDelete', {
        careerPathID: selectedCareerID,
      })
      .toPromise();
  }

  sendFileAttachmentRawDataToVP(
    moduleID: number,
    recordKeyID: number,
    fileAttachmentType: string,
    submissionGuid?: any,
    descriptionList?: string,
    fileDescription?: string,
    attachmentType?: string
  ) {
    return this.http
      .post('/Document/SendFileAttachmentRawDataToVP', {
        moduleID: moduleID,
        recordKeyID: recordKeyID,
        fileAttachmentType: fileAttachmentType,
        submissionGuid: submissionGuid,
        descriptionList: descriptionList,
        fileDescription: fileDescription,
        attachmentType: attachmentType,
      })
      .toPromise();
  }

  getProxyEmployees() {
    var url = '/Employee/GetProxyEmployees';
    return this.http.get(url).toPromise();
  }

  getPendingLines() {
    return this.http.get('/Employee/GetPendingLines').toPromise();
  }

  getSubmittedHeaders(startDateStr: any, endDateStr: any, selectedEmployee: any) {
    var url =
      '/Employee/GetSubmittedHeaders?startDateStr=' +
      startDateStr +
      '&endDateStr=' +
      endDateStr +
      '&userKeyID=' +
      (selectedEmployee == null ? null : selectedEmployee.UserKeyID);
    return this.http.get(url).toPromise();
  }

  deleteReceiptItem(expenseReceiptID: any, receiptItemID?: number, fromApproval = false) {
    return this.http
      .post('/Employee/DeleteReceiptItem', {
        expenseReceiptID: expenseReceiptID,
        receiptItemID: receiptItemID,
        fromApproval: fromApproval,
      })
      .toPromise();
  }

  deleteExpenseReceiptBulk(receiptIDs: any) {
    return this.http
      .post('/Employee/DeleteExpenseReceiptBulk', {
        receiptIDs: receiptIDs,
      })
      .toPromise();
  }

  exportExpenseReport(expenseHeaderID: number, headerDescription: any) {
    var url = '/Employee/ExportExpenseReport?ExpenseHeaderID=' + expenseHeaderID + '&filenames=' + headerDescription;
    return this.http.get(url).toPromise();
  }

  copyExpenseLine(copyFromReceiptID: number) {
    return this.http
      .post('/Employee/CopyExpenseLine', {
        copyFromReceiptID: copyFromReceiptID,
      })
      .toPromise();
  }

  bulkEditItems(
    expenseReceiptIDString: string,
    receiptItemIDString: string,
    expenseCatgID: number,
    jCCo: number,
    job: string,
    phase: string,
    gLCo: number,
    gLAcct: string,
    sMCo: number,
    sMWorkOrder: number,
    eMCo: number,
    workOrder: string,
    jCCType: number,
    sL: string,
    sLItem: any,
    wO: string,
    wOItem: any,
    equip: string,
    costCode: string,
    eMCType: any,
    compType: string,
    component: string,
    iNCo: any,
    loc: string,
    material: string,
    scope: number,
    pOItemLine: number,
    sMCostType: any,
    itemType: number,
    proxyUserKeyID: number,
    earnCode: number
  ) {
    return this.http
      .post('/Employee/BulkEditItems', {
        expenseReceiptIDString: expenseReceiptIDString,
        receiptItemIDString: receiptItemIDString,
        expenseCatgID: expenseCatgID,
        jCCo: jCCo,
        job: job,
        phase: phase,
        gLCo: gLCo,
        gLAcct: gLAcct,
        sMCo: sMCo,
        sMWorkOrder: sMWorkOrder,
        eMCo: eMCo,
        workOrder: workOrder,
        jCCType: jCCType,
        sL: sL,
        sLItem: sLItem,
        wO: wO,
        wOItem: wOItem,
        equip: equip,
        costCode: costCode,
        eMCType: eMCType,
        compType: compType,
        component: component,
        iNCo: iNCo,
        loc: loc,
        material: material,
        scope: scope,
        pOItemLine: pOItemLine,
        sMCostType: sMCostType,
        itemType: itemType,
        proxyUserKeyID: proxyUserKeyID,
        earnCode: earnCode,
      })
      .toPromise();
  }

  getCurrentWindow(proxyUserKeyID?: number) {
    var url = '/Employee/GetCurrentWindow?proxyUserKeyID=' + proxyUserKeyID;
    return this.http.get(url).toPromise();
  }

  getWindowTypes(includeOpenWindow: boolean) {
    var url = '/Employee/GetWindowTypes?includeOpenWindow=' + includeOpenWindow;
    return this.http.get(url).toPromise();
  }

  getBenefitGroupAttachments(proxyUserKeyID: number) {
    var url = '/Employee/GetBenefitGroupAttachments?proxyUserKeyID=' + proxyUserKeyID;
    return this.http.get(url).toPromise();
  }

  getBenefitsGrid(proxyUserKeyID: number) {
    var url = '/Employee/GetBenefitsGrid?proxyUserKeyID=' + proxyUserKeyID;
    return this.http.get(url).toPromise();
  }

  getPlanAttachments(benefitType?: string, attachmentID?: string) {
    var url = '/Employee/GetPlanAttachments?benefitType=' + benefitType + '&attachmentID=' + attachmentID;
    return this.http.get(url).toPromise();
  }

  getDependentsByBenefitCode(hRBCKeyID: number, proxyUserKeyID?: number) {
    var url = '/Employee/GetDependentsByBenefitCode?hRBCKeyID=' + hRBCKeyID + '&proxyUserKeyID=' + proxyUserKeyID;
    return this.http.get(url).toPromise();
  }

  getBenefitDependentsByRequestID(benefitRequestID: number) {
    var url = '/Employee/GetBenefitDependentsByRequestID?benefitRequestID=' + benefitRequestID;
    return this.http.get(url).toPromise();
  }

  submitBenefitRequest(
    hRBCKeyID: number,
    benefitOption: number,
    declineNotes?: string,
    proxyUserKeyID?: number,
    fixedAmt?: number,
    fixedPct?: number
  ) {
    return this.http
      .post('/Employee/SubmitBenefitRequest', {
        hRBCKeyID: hRBCKeyID,
        benefitOption: benefitOption,
        declineNotes: declineNotes,
        proxyUserKeyID: proxyUserKeyID,
        fixedAmt: fixedAmt,
        fixedPct: fixedPct,
      })
      .toPromise();
  }

  cancelBenefitRequest(benefitRequestID: number, proxyUserKeyID?: number) {
    return this.http
      .post('/Employee/CancelBenefitRequest', {
        benefitRequestID: benefitRequestID,
        proxyUserKeyID: proxyUserKeyID,
      })
      .toPromise();
  }

  benefitDependentRequest(
    benefitRequestID: number,
    hRDPKeyID: number,
    dependentRequestID?: number,
    dependentType?: string,
    dependentNameFreeText?: string,
    dependentRelFreeText?: string
  ) {
    return this.http
      .post('/Employee/BenefitDependentRequest', {
        benefitRequestID: benefitRequestID,
        hRDPKeyID: hRDPKeyID,
        dependentRequestID: dependentRequestID,
        dependentType: dependentType,
        dependentNameFreeText: dependentNameFreeText,
        dependentRelFreeText: dependentRelFreeText,
      })
      .toPromise();
  }

  getBenefitRequestsByUserWindowID(userWindowID: number, benefitRequestID?: number, showApproved?: boolean, proxyUserKeyID?: number) {
    var url =
      '/Employee/GetBenefitRequestsByUserWindowID?userWindowID=' +
      userWindowID +
      '&benefitRequestID=' +
      benefitRequestID +
      '&showApproved=' +
      showApproved +
      '&proxyUserKeyID=' +
      proxyUserKeyID;
    return this.http.get(url).toPromise();
  }

  sendBenSign(benefitUserWindowID?: number, benefitSignatureStr?: string, latitude?: number, longitude?: number, proxyUserKeyID?: number) {
    return this.http
      .post('/Employee/sendBenSign', {
        benefitUserWindowID: benefitUserWindowID,
        benefitSignatureStr: benefitSignatureStr,
        latitude: latitude,
        longitude: longitude,
        proxyUserKeyID: proxyUserKeyID,
      })
      .toPromise();
  }

  getVistaOptions(optionType: string) {
    var url = '/Hiring/GetVistaOptions?optionType=' + optionType;
    return this.http.get(url).toPromise();
  }

  removeFileAttachment(fileAttachmentID: any) {
    return this.http.post<ApiResponse>('/Employee/RemoveFileAttachment', {
        fileAttachmentID: fileAttachmentID,
      })
      .toPromise();
  }

  getTrainingHistoryPost(
    hRCo: number,
    userKeyID: string,
    skillOrTraining: string,
    itemKeyID: number,
    categoryString: string,
    startDateStr: string,
    endDateStr: string,
    includeInactive: boolean,
    showOnlyMostRecent: boolean
  ) {
    return this.http
      .post('/Employee/GetTrainingHistoryPost', {
        hRCo: hRCo,
        userKeyID: userKeyID,
        skillOrTraining: skillOrTraining,
        itemKeyID: itemKeyID,
        categoryString: categoryString,
        startDateStr: startDateStr,
        endDateStr: endDateStr,
        includeInactive: includeInactive,
        showOnlyMostRecent: showOnlyMostRecent,
      })
      .toPromise();
  }

  saveTrainingGrid(
    hRCo: number,
    userKeyID: string,
    skillOrTraining: string,
    itemKeyID: number,
    categoryString: string,
    startDateStr: string,
    endDateStr: string,
    mode: string,
    includeInactive: boolean,
    showOnlyMostRecent: boolean,
    includeExpired: boolean,
    includeAttachment: boolean,
    type: string,
    triggerMail: boolean
  ) {
    return this.http
      .post('/Employee/SaveTrainingGrid', {
        hRCo: hRCo,
        userKeyID: userKeyID,
        skillOrTraining: skillOrTraining,
        itemKeyID: itemKeyID,
        categoryString: categoryString,
        startDateStr: startDateStr,
        endDateStr: endDateStr,
        mode: mode,
        includeInactive: includeInactive,
        showOnlyMostRecent: showOnlyMostRecent,
        includeExpired: includeExpired,
        includeAttachment: includeAttachment,
        type: type,
        triggerMail: triggerMail,
      })
      .toPromise();
  }

  downloadTrainingGrid(name: string, type: string) {
    var url = '/Employee/DownloadTrainingGrid?name=' + name + (type == 'Excel' ? '.xlsx' : '.pdf');
    return this.http.get(url).toPromise();
  }

  trainingAttachmentsGetList(hRTrainingKeyID: number, skillOrTraining: string) {
    var url = '/Employee/TrainingAttachmentsGetList?hRTrainingKeyID=' + hRTrainingKeyID + '&skillOrTraining=' + skillOrTraining;
    return this.http.get(url).toPromise();
  }

  showClassDescription() {
    var url = '/Employee/ShowClassDescription';
    return this.http.get(url).toPromise();
  }

  trainingUpdate(
    itemKeyID: number,
    userKeyID: number[],
    skillOrTraining: string,
    code: string[],
    notes: string,
    dateTakenStr: string,
    dateExpiresStr: string,
    status: string,
    instructorName: string,
    grade: string,
    oSHA: string,
    mSHA: string,
    firstAid: string,
    cPR: string,
    workRelated: string,
    mode: string,
    attachmentData: any,
    attachmentName: string[]
  ) {
    return this.http
      .post('/Employee/TrainingUpdate', {
        itemKeyID: itemKeyID,
        userKeyID: userKeyID,
        skillOrTraining: skillOrTraining,
        code: code,
        notes: notes,
        dateTakenStr: dateTakenStr,
        dateExpiresStr: dateExpiresStr,
        status: status,
        instructorName: instructorName,
        grade: grade,
        oSHA: oSHA,
        mSHA: mSHA,
        firstAid: firstAid,
        cPR: cPR,
        workRelated: workRelated,
        mode: mode,
        attachmentData: attachmentData,
        attachmentName: attachmentName,
      })
      .toPromise();
  }

  trainingAttachmentDelete(attachmentID: number) {
    return this.http
      .post('/Employee/TrainingAttachmentDelete', {
        attachmentID: attachmentID,
      })
      .toPromise();
  }

  trainingDeleteItem(itemKeyID: number, skillOrTraining: any) {
    return this.http
      .post('/Employee/TrainingDeleteItem', {
        itemKeyID: itemKeyID,
        skillOrTraining: skillOrTraining,
      })
      .toPromise();
  }

  getUserGridSettings(gridLocation: string) {
    var url = '/Employee/GetUserGridSettings?gridLocation=' + gridLocation;
    return this.http.get<string[]>(url).toPromise();
  }

  setUserGridSettings(gridLocation: string, gridData: string) {
    return this.http
      .post('/Employee/SetUserGridSettings', {
        gridLocation: gridLocation,
        gridData: gridData,
      })
      .toPromise();
  }

  setUserVendor(userID: any, expenseAPVMKeyID: any) {
    return this.http
      .post('/Employee/SetUserVendor', {
        userID: userID,
        expenseAPVMKeyID: expenseAPVMKeyID,
      })
      .toPromise();
  }

  getFileAttachmentBinary(fileAttachmentID: number) {
    var url = '/Employee/GetFileAttachmentBinary?fileAttachmentID=' + fileAttachmentID;
    return this.http.get(url).toPromise();
  }

  updateOnboardTaskComplete(recordID: number) {
    return this.http
      .post('/Employee/UpdateOnboardTaskComplete', {
        recordID: recordID,
      })
      .toPromise();
  }

  clearBatchStatus(expenseReceiptIDString: string) {
    return this.http
      .post('/Employee/ClearBatchStatus', {
        expenseReceiptIDString: expenseReceiptIDString,
      })
      .toPromise();
  }

  getVendors(searchString: string) {
    var url = '/Employee/GetVendors?searchString=' + searchString;
    return this.http.get(url).toPromise();
  }

  getApprovalHistoryByItem(receiptItemID: string) {
    var url = '/Employee/GetApprovalHistoryByItem?receiptItemID=' + receiptItemID;
    return this.http.get(url).toPromise();
  }

  approveItems(receiptItemIDString: string, status: string, statusNotes: string) {
    return this.http
      .post('/Employee/ApproveItems', {
        receiptItemIDString: receiptItemIDString,
        status: status,
        statusNotes: statusNotes,
      })
      .toPromise();
  }

  getPayPeriods(prco: any, pRGroup: any) {
    var url = '/Employee/GetPayPeriods?pRCo=' + prco + '&pRGroup=' + pRGroup;
    return this.http.get(url).toPromise();
  }

  getPaySeq(pRPCKeyID: any) {
    var url = '/Employee/GetPaySeq?pRPCKeyID=' + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  processExpense(
    method: any,
    pRPCKeyID: any,
    paySeq: any,
    earnCode: any,
    receiptIDList: any,
    pRCo: any,
    mthStr: any,
    aPRef: any,
    hQBCKeyID?: any,
    aPVMKeyID?: number
  ) {
    return this.http
      .post('/Employee/ProcessExpense', {
        method: method,
        pRPCKeyID: pRPCKeyID,
        paySeq: paySeq,
        earnCode: earnCode,
        receiptIDList: receiptIDList,
        pRCo: pRCo,
        mthStr: mthStr,
        aPRef: aPRef,
        hQBCKeyID: hQBCKeyID,
        aPVMKeyID: aPVMKeyID,
      })
      .toPromise();
  }

  getReprocessBatches(pRCo: any) {
    var url = '/Employee/GetReprocessBatches?pRCo=' + pRCo;
    return this.http.get(url).toPromise();
  }

  getUnSubmittedExpenseReminder(sendEmail: any, pRCo: any) {
    return this.http
      .post('/Employee/GetUnSubmittedExpenseReminder', {
        sendEmail: sendEmail,
        pRCo: pRCo,
      })
      .toPromise();
  }

  getCreditCardvendors(pRCo: number) {
    var url = '/employee/GetCreditCardVendors?pRCo=' + pRCo;
    return this.http.get(url).toPromise();
  }

  insertUpdateReceipt(
    receiptID: any,
    userKeyID: any,
    PRCo: number,
    description?: string,
    expenseDateStr?: string,
    expenseCatgID?: any,
    vendor?: string,
    note?: string,
    expenseTransID?: number,
    reimburseOrMileage?: string,
    attendeeName?: string,
    customerName?: string,
    customerCount?: any,
    ourFirmCount?: any,
    units?: any,
    uM?: string,
    unitCost?: any,
    taxType?: any,
    taxCode?: string,
    taxAmount?: any,
    amount?: number,
    fromApproval?: boolean
  ) {
    return this.http
      .post('/Employee/InsertUpdateReceipt', {
        receiptID: receiptID,
        userKeyID: userKeyID,
        PRCo: PRCo,
        description: description,
        expenseDateStr: expenseDateStr,
        expenseCatgID: expenseCatgID,
        vendor: vendor,
        note: note,
        expenseTransID: expenseTransID,
        reimburseOrMileage: reimburseOrMileage,
        attendeeName: attendeeName,
        customerName: customerName,
        customerCount: customerCount,
        ourFirmCount: ourFirmCount,
        units: units,
        uM: uM,
        unitCost: unitCost,
        taxType: taxType == 0 || taxType == -1 ? null : taxType,
        taxCode: taxCode,
        taxAmount: taxAmount,
        amount: amount,
        fromApproval: fromApproval ?? false,
      })
      .toPromise();
  }

  getExpenseReceipts(requestParam: string) {
    var url = '/Employee/GetExpenseReceipts?' + requestParam;
    return this.http.get(url).toPromise();
  }

  getExpenseDashboard(
    pRCo?: any,
    startDateStr?: any,
    endDateStr?: any,
    pRGroup?: any,
    transType?: any,
    statusLabel?: any,
    employeeID?: any,
    minAmount?: any,
    maxAmount?: any,
    receiptID?: any
  ) {
    let params = new HttpParams();
    if (pRCo) params = params.set('pRCo', pRCo);
    if (startDateStr) params = params.set('startDateStr', startDateStr);
    if (endDateStr) params = params.set('endDateStr', endDateStr);
    if (pRGroup) params = params.set('pRGroup', pRGroup);
    if (transType) params = params.set('transType', transType);
    if (statusLabel) params = params.set('statusLabel', statusLabel);
    if (employeeID) params = params.set('employeeID', employeeID);
    if (minAmount) params = params.set('minAmount', minAmount);
    if (maxAmount) params = params.set('maxAmount', maxAmount);
    if (receiptID) params = params.set('receiptID', receiptID);

    return this.http.get<ReceiptItem[]>('/Employee/GetExpenseDashboard', { params }).toPromise();
  }

  insertUpdateReceiptItem(
    receiptItemID?: any,
    receiptID?: any,
    amount = 0,
    taxAmount?: any,
    jCCo?: any,
    job?: string,
    phase?: string,
    gLCo?: any,
    gLAcct?: string,
    sMCo?: any,
    sMWorkOrder?: any,
    eMCo?: any,
    jCCType?: any,
    pO?: string,
    pOItem?: any,
    sL?: string,
    sLItem?: any,
    wO?: string,
    wOItem?: any,
    equip?: string,
    costCode?: string,
    eMCType?: any,
    compType?: string,
    component?: string,
    iNCo?: any,
    loc?: string,
    material?: string,
    scope?: any,
    pOItemLine?: any,
    sMCostType?: any,
    itemType?: any,
    earnCode?: any,
    reviewerSeq?: number,
    copiedReceiptItemID?: number,
    fromApproval?: boolean
  ) {
    return this.http
      .post('/Employee/InsertUpdateReceiptItem', {
        receiptItemID: receiptItemID,
        receiptID: receiptID,
        amount: amount,
        taxAmount: taxAmount,
        jCCo: jCCo,
        job: job,
        phase: phase,
        gLCo: gLCo,
        gLAcct: gLAcct,
        sMCo: sMCo,
        sMWorkOrder: sMWorkOrder,
        eMCo: eMCo,
        jCCType: jCCType,
        pO: pO,
        pOItem: pOItem,
        sL: sL,
        sLItem: sLItem,
        wO: wO,
        wOItem: wOItem,
        equip: equip,
        costCode: costCode,
        eMCType: eMCType,
        compType: compType,
        component: component,
        iNCo: iNCo,
        loc: loc,
        material: material,
        scope: scope,
        pOItemLine: pOItemLine,
        sMCostType: sMCostType,
        itemType: itemType,
        earnCode: earnCode,
        reviewerSeq: reviewerSeq,
        copiedReceiptItemID: copiedReceiptItemID,
        fromApproval: fromApproval,
      })
      .toPromise();
  }

  getExpenseReceiptLines(receiptIDString: string, fromApproval = false) {
    return this.http
      .post('/Employee/GetExpenseReceiptLines', {
        receiptIDString: receiptIDString,
        fromApproval: fromApproval,
      })
      .toPromise();
  }

  getExpenseReceiptItemByID(receiptItemID: number) {
    var url = '/Employee/GetExpenseReceiptItemByID?receiptItemID=' + receiptItemID;
    return this.http.get(url).toPromise();
  }

  addReceiptLineNotes(receiptItemID: number, notes: string) {
    return this.http
      .post('/Employee/AddReceiptLineNotes', {
        receiptItemID: receiptItemID,
        notes: notes,
      })
      .toPromise();
  }

  getPOLookup(userKeyID?: number, receiptID?: number) {
    var url = '/Employee/GetPOLookup?userKeyID=' + userKeyID + '&receiptID=' + receiptID;
    return this.http.get(url).toPromise();
  }

  upDepartments(departmentID?: number, departmentName?: string, assigneeSecurityGroup?: number, isActive?: boolean) {
    return this.http
      .post('/Employee/UpDepartments', {
        departmentID: departmentID,
        departmentName: departmentName,
        assigneeSecurityGroup: assigneeSecurityGroup,
        isActive: isActive,
      })
      .toPromise();
  }

  updateWindowTypes(
    windowTypeID: number,
    windowShortName: string,
    windowDisplayName: string,
    windowDefaultDurationDays?: number,
    windowTypeIsActive?: boolean,
    windowAttachmentReq?: boolean,
    windowNotesReq?: boolean
  ) {
    return this.http
      .post('/Employee/UpdateWindowTypes', {
        windowTypeID: windowTypeID,
        windowShortName: windowShortName,
        windowDisplayName: windowDisplayName,
        windowDefaultDurationDays: windowDefaultDurationDays,
        windowTypeIsActive: windowTypeIsActive,
        windowAttachmentReq: windowAttachmentReq,
        windowNotesReq: windowNotesReq,
      })
      .toPromise();
  }

  getAttachmentsBySubmissionID(submissionGuid: any) {
    var url = '/Employee/GetAttachmentsBySubmissionID?submissionGuid=' + submissionGuid;
    return this.http.get(url).toPromise();
  }

  secondStepSubmit(bulletinResponseID: any, bulletinFileData: any) {
    return this.http
      .post('/Employee/SecondStepSubmit', {
        bulletinResponseID: bulletinResponseID,
        bulletinFileData: bulletinFileData,
      })
      .toPromise();
  }

  getJobs(form: string, searchString: string) {
    var url = '/Employee/GetJobs?form=' + form + '&searchString=' + searchString;
    return this.http.get(url).toPromise();
  }

  getPhasesByJCJMKeyID(jCJMKeyID: number, laborOnly?: boolean) {
    var url = '/Employee/GetPhasesByJCJMKeyID?jCJMKeyID=' + jCJMKeyID + '&laborOnly=' + laborOnly;
    return this.http.get(url).toPromise();
  }

  clearAndResubmitStateForm(bulletinID: any) {
    return this.http
      .post('/Employee/ClearAndResubmitStateForm', {
        bulletinID: bulletinID,
      })
      .toPromise();
  }

  getPhasesForClockIn(jCJMKeyID?: number, jobsAccessToken?: any, fromClockDashboard?: boolean, kioskPass?: string) {
    var url =
      '/Employee/GetPhasesForClockIn?jCJMKeyID=' +
      jCJMKeyID +
      '&jobsAccessToken=' +
      jobsAccessToken +
      '&fromClockDashboard=' +
      fromClockDashboard +
      '&kioskPass=' +
      kioskPass;
    return this.http.get(url).toPromise();
  }

  async updateHRUser(user: User): Promise<ApiResponse> {
    return await (<Promise<ApiResponse>>this.http.post('/Employee/UpdateHRUser', user).toPromise());
  }

  async setDocConsent(params: HttpParams) {
    return this.http.post('/Employee/SetDocConsent', params).toPromise();
  }

  saveParameter(parameter: string, parameterNew: string) {
    return this.http
      .post('/Employee/SaveParameter', {
        parameter: parameter,
        parameterNew: parameterNew,
      })
      .toPromise();
  }

  deleteBulletinResponse(bulletinID: any) {
    return this.http
      .post('/Employee/DeleteBulletinResponse', {
        bulletinID: bulletinID,
      })
      .toPromise();
  }

  getClockInStatus(requestParam: any) {
    var url = '/Employee/GetClockInStatus?' + requestParam;
    return this.http.get(url).toPromise();
  }

  postClockAction(requestObj: any) {
    return this.http.post('/Employee/PostClockAction', requestObj).toPromise();
  }

  getClockHistory(pRCo?: number, employee?: number, kioskPass?: string) {
    var url = '/Employee/GetClockHistory?pRCo=' + pRCo + '&employee=' + employee + '&kioskPass=' + kioskPass;
    return this.http.get(url).toPromise();
  }

  getPREHKeyIDByEmployee(pRCo: number, employee: number, kioskPass?: string) {
    var url = '/Employee/GetPREHKeyIDByEmployee?pRCo=' + pRCo + '&employee=' + employee + '&kioskPass=' + kioskPass;
    return this.http.get(url).toPromise();
  }

  postClockActionAnon(requestObj: any) {
    let params = new HttpParams();
    if (requestObj.gPSLat) params = params.set('gPSLat', requestObj.gPSLat);
    if (requestObj.gPSLong) params = params.set('gPSLong', requestObj.gPSLong);
    if (requestObj.clockAction) params = params.set('clockAction', requestObj.clockAction);
    if (requestObj.employee) params = params.set('employee', requestObj.employee);
    if (requestObj.pRCo) params = params.set('pRCo', requestObj.pRCo);
    if (requestObj.jCJMKeyID) params = params.set('jCJMKeyID', requestObj.jCJMKeyID);
    if (requestObj.jCJPKeyID) params = params.set('jCJPKeyID', requestObj.jCJPKeyID);
    if (requestObj.clockTimeString) params = params.set('clockTimeString', requestObj.clockTimeString);
    if (requestObj.sMWorkOrderScopeID) params = params.set('sMWorkOrderScopeID', requestObj.sMWorkOrderScopeID);
    if (requestObj.sMPayType) params = params.set('sMPayType', requestObj.sMPayType);
    if (requestObj.sMTripID) params = params.set('sMTripID', requestObj.sMTripID);
    if (requestObj.fromGroupClock) params = params.set('fromGroupClock', requestObj.fromGroupClock);
    if (requestObj.kioskPass) params = params.set('kioskPass', requestObj.kioskPass);
    if (requestObj.mealBreak) params = params.set('mealBreak', requestObj.mealBreak);
    return this.http.post('/Employee/PostClockActionAnon', params).toPromise();
  }

  unlockClockInPage(unlockPassword: any) {
    return this.http
      .post('/Employee/UnlockClockInPage', {
        unlockPassword: unlockPassword,
      })
      .toPromise();
  }

  getJobsForClockIn(pRCo?: number, employee?: number, searchText?: string, jobsAccessToken?: any, kioskPass?: string) {
    var url =
      '/Employee/GetJobsForClockIn?pRCo=' +
      pRCo +
      '&employee=' +
      employee +
      '&searchText=' +
      searchText +
      '&jobsAccessToken=' +
      jobsAccessToken +
      '&kioskPass=' +
      kioskPass;
    return this.http.get(url).toPromise();
  }

  updateReviewer(reviewer: string, receiptIDList: any[] = [], receiptItemID?: number) {
    return this.http
      .post('/Employee/UpdateReviewer', {
        reviewer: reviewer,
        receiptIDList: receiptIDList,
        receiptItemID: receiptItemID,
      })
      .toPromise();
  }

  getReviewerAssignmentStatus(receiptIDString: string) {
    var url = '/Employee/GetReviewerAssignmentStatus?receiptIDString=' + receiptIDString;
    return this.http.get(url).toPromise();
  }

  getWorkOrderScopesAnon(sMWorkOrderID: number, kioskPass?: string) {
    const url = '/Employee/GetWorkOrderScopesAnon';
    let params = new HttpParams();
    params = params.set('sMWorkOrderID', sMWorkOrderID);
    if (kioskPass) params = params.set('kioskPass', kioskPass);
    return this.http.get(url, { params: params }).toPromise();
  }

  getSMPayTypesAnon(sMCo: number, kioskPass?: string) {
    const url = '/Employee/GetSMPayTypesAnon';
    let params = new HttpParams();
    params = params.set('sMCo', sMCo);
    if (kioskPass) params = params.set('kioskPass', kioskPass);
    return this.http.get(url, { params: params }).toPromise();
  }

  getWorkOrderTripsByEmployeeAnon(pRCo: number, employee: number, kioskPass?: string) {
    const url = '/Employee/GetWorkOrderTripsByEmployeeAnon';
    let params = new HttpParams();
    params = params.set('prco', pRCo);
    params = params.set('employee', employee);
    if (kioskPass) params = params.set('kioskPass', kioskPass);
    return this.http.get(url, { params: params }).toPromise();
  }

  getEmployeeInfoAnon(pRCo: number, employee: number, kioskPass: string): Promise<EmployeeInfo> {
    const url = '/Employee/getEmployeeInfoAnon';
    const params = new HttpParams().set('pRCo', pRCo).set('employee', employee).set('kioskPass', kioskPass);
    return this.http.get<EmployeeInfo>(url, { params: params }).toPromise();
  }
}

export interface LineAttachment {
  ExpenseAttachmentID: number;
  FileAttachmentID: string;
  AttachmentFileName: string;
  FileDisplayName: string;
  AttachmentCaption: string | null;
  AttacmentFileData: string | null;
  ReceiptID: number | null;
  ReceiptItemID: number | null;
}
